module.exports = __webpack_public_path__ + "static/media/favorite.b224a1af.svg";